import { ObjectID } from 'bson';
import { Schema } from 'mongoose';

export interface IAccommodationProps {
  stars?: number;
  amenities: ObjectID[];
  checkIn?: IFromTo;
  checkOut?: IFromTo;
}

interface IFromTo {
  from?: number;
  to?: number;
}
// stored in minutes, eg.
// 0 = 00:00
// 60 = 01:00
// 252 = 04:12
const fromTo = new Schema(
  {
    from: {
      type: Number,
      required: false,
    },
    to: {
      type: Number,
      required: false,
    },
  },
  { _id: false },
);

const schema = new Schema(
  {
    stars: {
      type: Number,
      default: undefined,
      required: false,
    },
    amenities: {
      type: [
        {
          type: Schema.Types.ObjectId,
          ref: 'Amenities',
          required: true,
        },
      ],
      default: [],
    },
    checkIn: {
      type: fromTo,
    },
    checkOut: {
      type: fromTo,
    },
  },
  { _id: false },
);

export default schema;
